import React from "react";
import { Box } from "@mui/material";
import { HeroSection } from "./components/HeroSection";
import { FeaturesSection } from "./components/FeaturesSection";
import { StatsSection } from "./components/StatsSection";
import { ComparisonSection } from "./components/ComparisonSection";
import { TestimonialsSection } from "./components/TestimonialsSection";

export const LandingPage: React.FC = () => {
  return (
    <Box sx={{ overflow: "hidden" }}>
      <HeroSection />
      <StatsSection />
      <FeaturesSection />
      <ComparisonSection />
      {/* <TestimonialsSection /> */}
    </Box>
  );
};
